import { Grid, Tab, Tabs } from '@mui/material'
import { useCallback, useState } from 'react'
import { useSearch } from '@/features/search/hooks/useSearch'
import { useBreakpointWidth } from '@/layout/hooks/useBreakpointWidth'
import { createDefaultSearchState } from '../defaults'
import type { SearchFilterState } from '../types'
import { FilterActions } from './FilterActions'
import { DocumentInformation } from './sections/DocumentInformation'
import { MediaDetails } from './sections/MediaDetails'
import { ProductInformation } from './sections/ProductInformation'
import { TextSearch } from './sections/TextSearch'

type MenuItem = {
  label: string
  component: JSX.Element
  defaults: Partial<SearchFilterState>
}

type Props = {
  onClose?: () => void
}
export const Filters = (props: Props) => {
  const { applyNextSearch, updateNext, setNext } = useSearch()
  const [page, setPage] = useState(0)
  const breakpointWidth = useBreakpointWidth()
  const defaultSearchState = createDefaultSearchState()

  const menuItems: MenuItem[] = [
    {
      label: 'Media Details',
      component: <MediaDetails />,
      defaults: {
        mediaType: defaultSearchState.mediaType,
        industries: defaultSearchState.industries,
        status: defaultSearchState.status,
        mediaDetails: defaultSearchState.mediaDetails,
      },
    },
    {
      label: 'Document Information',
      component: <DocumentInformation />,
      defaults: { documentInformation: defaultSearchState.documentInformation },
    },
    {
      label: 'Product Information',
      component: <ProductInformation />,
      defaults: { productInformation: defaultSearchState.productInformation },
    },
    {
      label: 'Text Search',
      component: <TextSearch />,
      defaults: { searchText: defaultSearchState.searchText },
    },
  ]

  const currentPage = menuItems[page]

  const handleResetAll = useCallback(() => {
    setNext(createDefaultSearchState())
  }, [setNext])

  const handleResetSection = useCallback(() => {
    updateNext(currentPage.defaults)
  }, [currentPage, updateNext])

  const handleSubmit = useCallback(() => {
    applyNextSearch()
    props.onClose?.()
  }, [applyNextSearch, props.onClose])

  const tabs = menuItems.map((item, idx) => (
    <Tab key={item.label} label={item.label} value={idx} />
  ))

  return (
    <Grid width={breakpointWidth} container columns={12}>
      <Grid bgcolor={'#ccd2d9'}>
        <Tabs
          orientation="vertical"
          value={page}
          onChange={(_event, value) => setPage(value)}
        >
          {tabs}
        </Tabs>
      </Grid>
      <Grid size={{ xs: 12, md: 'grow' }} p={1}>
        {currentPage.component}
      </Grid>
      <Grid size={12} p={1} bgcolor={'#bbc1c8'}>
        <FilterActions
          onResetAll={handleResetAll}
          onResetSection={handleResetSection}
          onSubmit={handleSubmit}
        />
      </Grid>
    </Grid>
  )
}
